export default __webpack_public_path__ + "static/media/ringtone.30624d58.wav";